import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled from 'styled-components';
import { getAssetIcon } from 'utils/icons';
import getImageUrlSuffix from 'utils/image/getImageUrlSuffix';
import AssetIcon from 'components/AssetIcon';
import Box from 'components/Box';
import ButtonCore from 'components/ButtonCore';
import useBreakpoints from 'hooks/useBreakpoints';
import Card from 'components/Card';
import CardImage from 'components/CardImage';
import CenterContent from 'components/CenterContent';
import ViewMoreText from 'components/ViewMoreText';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var maxPanelWidth = 420;
var pictureUrlSuffix = getImageUrlSuffix({
  width: maxPanelWidth
});
var ButtonBlock = styled(ButtonCore).withConfig({
  displayName: "ButtonPanel__ButtonBlock",
  componentId: "sc-15scbde-0"
})(["display:block;width:100%;"]);
function ButtonPanel(_ref) {
  var asset = _ref.asset,
    imageButtonProps = _ref.imageButtonProps,
    children = _ref.children;
  var description = asset.description,
    pictureUrl = asset.pictureUrl;
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.xs;
  var assetIcon = getAssetIcon(asset);
  var hasCard = pictureUrl || description;
  return /*#__PURE__*/_jsxs(CenterContent, {
    contentWidth: maxPanelWidth,
    fillParent: isDesktop,
    height: isDesktop ? null : 200,
    children: [hasCard && /*#__PURE__*/_jsxs(Card, {
      children: [pictureUrl && /*#__PURE__*/_jsx(ButtonBlock, _objectSpread(_objectSpread({}, imageButtonProps), {}, {
        "aria-hidden": "true",
        role: "presentation",
        tabIndex: "-1",
        children: /*#__PURE__*/_jsx(CardImage, {
          lazyload: false,
          src: pictureUrl && pictureUrl + pictureUrlSuffix,
          colorBlock: assetIcon,
          aspectRatio: 2 / 3,
          fallbackContent: /*#__PURE__*/_jsx(AssetIcon, {
            name: assetIcon,
            size: "big"
          })
        })
      })), description && /*#__PURE__*/_jsx(Box, {
        p: "s",
        pb: "m",
        fontSize: "s",
        children: /*#__PURE__*/_jsx(ViewMoreText, {
          content: description,
          maxLength: isDesktop ? 400 : 90
        })
      })]
    }), /*#__PURE__*/_jsx(Box, {
      textAlign: "center",
      mt: hasCard ? '-s' : null,
      children: children
    })]
  });
}
export default ButtonPanel;